import http from '../interceptors/Intercepter';

export const retrieveCAPAs = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/CAPA/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createCAPA = async (username, capaVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/CAPA/create', capaVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewCAPA = async (username, capaExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
      capaExternalReference: capaExternalReference,
    };

    const { data } = await http.get('/api/CAPA/view', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateCAPA = async (username, capaVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.put('/api/CAPA/update', capaVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
